import axios from "axios";

export function clearNotification(url) {
  return axios.get(url);
}